import { Link, useNavigate } from 'react-router-dom';
import { useSignOut } from '@/hooks/api/0060_sign_out';
import { useLoading } from '@/providers/LoadingProvider';
import { useEffect } from 'react';
import { toastSuccess } from '@/lib/toast';
import queryClient from '@/lib/queryClient';

export const MyProfileMenuButtonGroup = () => {
  const { mutate, isSuccess, isPending } = useSignOut();
  const { setShowLoading } = useLoading();
  const navigate = useNavigate();

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (isSuccess) {
      toastSuccess('サインアウトしました');
      navigate(`/sign_in`);
      queryClient.clear();
    }
  }, [isSuccess]);

  const onSignOutClick = () => {
    mutate();
  };

  return (
    <div className="col-lg-3 col-md-7">
      <ul className="nav flex-column bg-white border-radius-lg p-3 mb-4 position-relative">
        <li className="nav-item">
          <Link className="nav-link text-body" data-scroll="" to={`/my_profile`}>
            <div className="icon me-2">
              <i className="fas fa-user text-dark"></i>
            </div>
            <span className="text-sm">ユーザー情報編集</span>
          </Link>
        </li>
        <li className="nav-item pt-2">
          <Link className="nav-link text-body" data-scroll="" to={`/my_profile/edit_password`}>
            <div className="icon me-2">
              <i className="fas fa-lock text-dark"></i>
            </div>
            <span className="text-sm">パスワード変更</span>
          </Link>
        </li>
        <li className="nav-item pt-2">
          <Link className="nav-link text-body" data-scroll="" to="" onClick={onSignOutClick}>
            <div className="icon me-2">
              <i className="fas fa-sign-out-alt text-danger"></i>
            </div>
            <span className="text-sm text-danger">サインアウト</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};
